import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconStudioFiles(props: SvgIconProps) {
  return (
    <SVGIcon xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <path
        fill="currentColor"
        d="m13.354 4.146-2.5-2.5A.5.5 0 0 0 10.5 1.5h-5a1 1 0 0 0-1 1v1h-1a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1v-1h1a1 1 0 0 0 1-1v-7a.5.5 0 0 0-.146-.354M10.5 13.5h-7v-9h4.793L10.5 6.707zm2-2h-1v-5a.5.5 0 0 0-.146-.354l-2.5-2.5A.5.5 0 0 0 8.5 3.5h-3v-1h4.793L12.5 4.707zM9 9.5a.5.5 0 0 1-.5.5h-3a.5.5 0 1 1 0-1h3a.5.5 0 0 1 .5.5m0 2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1 0-1h3a.5.5 0 0 1 .5.5"
      />
    </SVGIcon>
  );
}
